import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Redirect, withRouter } from 'react-router-dom';
import ReactRouterPropTypes from 'react-router-prop-types';
import { connect } from 'react-redux';
import MediaPage from '../components/Media/MediaPage';
import getWorkRecord from '../actions/api/record/getWorkRecord';
import * as types from '../lib/constants';

const INTERVAL_TIMER = 10000;

const updateContainer = (
  apiToken,
  mediaId,
  searchOptions,
  searchPosition,
  targetGroupId,
  dispatch,
) => {
  const { groupIds: timelineGroupIds, ...timelineSearchOptions } =
    searchOptions || {};
  const groupIds = (targetGroupId && [targetGroupId]) || timelineGroupIds;
  const options = { ...timelineSearchOptions, searchPosition, groupIds };
  // eslint-disable-next-line no-eq-null
  if (groupIds != null) {
    dispatch(getWorkRecord(apiToken, mediaId, options));
  }
};

const getMediaDetailHeight = () => {
  const title = document.getElementById('title');
  const height = title && title.clientHeight;
  return height || 0;
};

class MediaContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mediaDetailHeight: 0,
    };
    const params = {
      apiToken: props && props.apiToken,
      dispatch: (props && props.dispatch) || null,
      searchOptions: props && props.searchOptions,
      searchPosition: props && props.searchPosition,
      showUserPrompt: props && props.showUserPrompt,
      mediaId: props && props.match && props.match.params.mediaId,
      canUpdate: !props.showUserPrompt || props.isLogin,
      targetGroupId: props && props.targetGroupId,
    };
    if (params.canUpdate) {
      this.initialTimer(params);
    }
  }

  componentDidMount() {
    const mediaDetailHeight = getMediaDetailHeight();
    this.setState({ mediaDetailHeight });
  }

  shouldComponentUpdate(props, state) {
    const resizedMediaDetailHeight = getMediaDetailHeight();
    const curMediaDetailHeight = state.mediaDetailHeight;
    if (resizedMediaDetailHeight !== curMediaDetailHeight) {
      this.setState({ mediaDetailHeight: resizedMediaDetailHeight });
    }
    const params = {
      history: props && props.history,
      apiToken: props && props.apiToken,
      dispatch: (props && props.dispatch) || null,
      nextId: props && props.nextId,
      searchOptions: props && props.searchOptions,
      searchPosition: props && props.searchPosition,
      showUserPrompt: props && props.showUserPrompt,
      mediaId: props && props.match && props.match.params.mediaId,
      canUpdate: !props.showUserPrompt || props.isLogin,
      tagInfo: props && props.tagInfo,
      provider: props && props.provider,
      targetGroupId: props && props.targetGroupId,
    };
    if (
      params.searchPosition !== types.MEDIA_SEARCH_POSITION.current &&
      params.nextId &&
      Number(params.mediaId) !== params.nextId
    ) {
      params.dispatch({ type: 'CHANGE_WORK_RECORD' });
      this.closeTimer();
      params.history.push(
        `${params.provider.pathName}/ds/media/${params.nextId}`,
      );
      return true;
    }
    if (params.canUpdate) {
      this.initialTimer(params);
    }
    return true;
  }

  componentWillUnmount() {
    this.closeTimer();
  }

  initialTimer(params) {
    const {
      apiToken,
      mediaId,
      searchOptions,
      searchPosition,
      dispatch,
      showUserPrompt,
      targetGroupId,
    } = params;
    this.closeTimer();
    if (dispatch && apiToken && !showUserPrompt) {
      updateContainer(
        apiToken,
        mediaId,
        searchOptions,
        searchPosition,
        targetGroupId,
        dispatch,
      );
      this.mainTimer = setInterval(
        () =>
          updateContainer({
            apiToken,
            mediaId,
            searchOptions,
            searchPosition,
            targetGroupId,
            dispatch,
          }),
        INTERVAL_TIMER,
      );
    }
  }

  closeTimer() {
    if (this.mainTimer !== undefined) {
      clearInterval(this.mainTimer);
      delete this.mainTimer;
    }
  }

  render() {
    const { isLogin } = this.props;
    const { mediaDetailHeight } = this.state;
    return (
      (!isLogin && <Redirect to="/login" />) || (
        <MediaPage mediaDetailHeight={mediaDetailHeight} />
      )
    );
  }
}

MediaContainer.propTypes = {
  history: ReactRouterPropTypes.history.isRequired,
  apiToken: PropTypes.string.isRequired,
  isLogin: PropTypes.bool.isRequired,
  nextId: PropTypes.number,
  searchOptions: PropTypes.object.isRequired,
  searchPosition: PropTypes.string.isRequired,
  showUserPrompt: PropTypes.bool.isRequired,
  match: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  tagInfo: PropTypes.array.isRequired,
  provider: PropTypes.object.isRequired,
  targetGroupId: PropTypes.string.isRequired,
};

MediaContainer.defaultProps = {
  nextId: null,
};

const mapStateToProps = state => ({
  apiToken: state.main.apiToken,
  isLogin: state.main.isLogin,
  nextId: state.media.info.id,
  searchOptions: state.media.searchOptions,
  searchPosition: state.media.searchPosition,
  showUserPrompt: state.userPrompt.showUserPrompt,
  tagInfo: state.media.info.tags,
  provider: state.main.provider,
  targetGroupId: state.main.targetGroupId,
});

export default withRouter(connect(mapStateToProps)(MediaContainer));
